//
// Module for the Employment Codes Index view
//
rs.module("content/employer/account/employmentcodes/index",

    ["controls/data/grid"],

    function (gridModule) {

        // Initialize the module
        function initialize(lrsGridApi, jsSelectors, backendUrl) {

            var filter = $.js(jsSelectors.filter);
            var employmentCodeDropDown = filter.js(jsSelectors.employmentCodeDropDown);
            var loadingSpinner = filter.js(jsSelectors.loadingSpinner);

            var addButton = $.js(jsSelectors.addButton);

            // listen for Employment Code dropdown change
            employmentCodeDropDown.change(employmentCodeChanged);

            // Hookup Ajax to changing the selected audit status
            function employmentCodeChanged() {

                loadingSpinner.show();

                gridModule.update(
                    backendUrl,

                    { selectedEmploymentCodeGroup: employmentCodeDropDown.val() },

                    lrsGridApi.agGridApi,

                    function done(gridUpdate) {

                        // Update the Add button url which includes the new employment group code
                        addButton.attr('href', gridUpdate.context.addUrl);
                    }
                ).always(function () {
                    loadingSpinner.hide();
                });
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);